(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
(function(){ // Video JS IIFE
  function wireHtml5(holder){
    var vid = holder.querySelector('video');
    if(!vid) return false;
    var btn = holder.querySelector('[data-video-play]');
    var clickPause = holder.getAttribute('data-click-pause') === 'true';
    if(btn){ btn.addEventListener('click', function(){ vid.play().catch(function(){}); }); }
    vid.addEventListener('play',  function(){ holder.classList.add('is-playing'); holder.classList.remove('is-paused'); });
    vid.addEventListener('pause', function(){ holder.classList.remove('is-playing'); holder.classList.add('is-paused'); });
    if(clickPause){
      holder.addEventListener('click', function(e){
        var t = e.target;
        if(t.closest('a, button, [role="button"], .t4s-btn')) return;
        if(vid.paused) vid.play().catch(function(){}); else vid.pause();
      });
    }
    return true;
  }
  function wireExternal(holder){
    var iframe = holder.querySelector('iframe');
    if(!iframe) return false;
    var btn = holder.querySelector('[data-video-play]');
    function yt(cmd){ iframe.contentWindow && iframe.contentWindow.postMessage(JSON.stringify({event:'command',func:cmd,args:''}), '*'); }
    function vimeo(cmd){ iframe.contentWindow && iframe.contentWindow.postMessage({method:cmd}, '*'); }
    function isYT(){ return /youtube\.com|youtu\.be/.test(iframe.src); }
    function isVimeo(){ return /vimeo\.com/.test(iframe.src); }
    if(btn){ btn.addEventListener('click', function(){ if(isYT()) yt('playVideo'); else if(isVimeo()) vimeo('play'); holder.classList.add('is-playing'); holder.classList.remove('is-paused'); }); }
    return true;
  }
  document.querySelectorAll('.t4s-video-holder').forEach(function(h){ if(wireHtml5(h)) return; wireExternal(h); });
})();


(function(){
  function relayout(c){ var iso = window.Isotope && window.Isotope.data && window.Isotope.data(c); if(iso) iso.layout(); }
  function relayoutAll(){ document.querySelectorAll('.isotopet4s-enabled, [data-isotopet4s-js]').forEach(relayout); }
  window.addEventListener('load', function(){ setTimeout(relayoutAll, 400); setTimeout(relayoutAll, 1200); });
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t=setTimeout(relayoutAll, 200); });
  document.addEventListener('lazyloaded', function(){ setTimeout(relayoutAll, 200); });
})();

  } catch(e) { console.error(e); }
})();
})();
